import React from 'react';
import {
    Box,
    Grid,
    Card,
    CardContent,
    Skeleton,
    Stack,
    Paper
} from '@mui/material';

const DashboardSkeleton = () => {
    return (
        <Box>
            {/* Header Skeleton */}
            <Box 
                sx={{ 
                    mb: 4, 
                    p: 3,
                    borderRadius: 2,
                    background: 'linear-gradient(to right, #f5f5f5, #e0e0e0)',
                }}
            >
                <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems="center" spacing={2}>
                    <Box sx={{ flex: 1 }}>
                        <Skeleton variant="text" width="60%" height={40} sx={{ mb: 1 }} />
                        <Skeleton variant="text" width="80%" height={24} sx={{ mb: 1 }} />
                        <Skeleton variant="text" width="40%" height={20} />
                    </Box>
                    <Stack direction="row" spacing={1}>
                        <Skeleton variant="rectangular" width={140} height={36} sx={{ borderRadius: 1 }} />
                        <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: 1 }} />
                    </Stack>
                </Stack>
            </Box>

            {/* Quick Stats Row Skeleton */}
            <Grid container spacing={3} sx={{ mb: 4 }}>
                {[1, 2, 3, 4].map((item) => (
                    <Grid item xs={12} sm={6} md={3} key={item}>
                        <Card sx={{ borderRadius: 3, height: 160 }}>
                            <CardContent sx={{ p: 3 }}>
                                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                                    <Box sx={{ flex: 1 }}>
                                        <Skeleton variant="text" width="60%" height={16} sx={{ mb: 1 }} />
                                        <Skeleton variant="text" width="40%" height={32} sx={{ mb: 0.5 }} />
                                        <Skeleton variant="text" width="70%" height={14} />
                                    </Box>
                                    <Skeleton variant="circular" width={56} height={56} />
                                </Stack>
                                <Skeleton variant="rectangular" width="100%" height={6} sx={{ borderRadius: 3 }} />
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

            {/* Main Content Grid Skeleton */}
            <Grid container spacing={3}>
                {/* Left Column */}
                <Grid item xs={12} lg={8}>
                    {/* Chart Section */}
                    <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                        <Skeleton variant="text" width="30%" height={28} sx={{ mb: 2 }} />
                        <Skeleton variant="rectangular" width="100%" height={300} sx={{ borderRadius: 1 }} />
                    </Paper>

                    {/* Map Section */}
                    <Paper sx={{ p: 3, borderRadius: 2 }}>
                        <Skeleton variant="text" width="40%" height={28} sx={{ mb: 2 }} />
                        <Skeleton variant="rectangular" width="100%" height={400} sx={{ borderRadius: 1 }} />
                    </Paper>
                </Grid>

                {/* Right Column */}
                <Grid item xs={12} lg={4}>
                    {/* Activity Section */}
                    <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                        <Skeleton variant="text" width="50%" height={28} sx={{ mb: 2 }} />
                        {[1, 2, 3, 4, 5].map((item) => (
                            <Stack key={item} direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                                <Skeleton variant="circular" width={40} height={40} />
                                <Box sx={{ flex: 1 }}>
                                    <Skeleton variant="text" width="80%" height={16} />
                                    <Skeleton variant="text" width="60%" height={14} />
                                </Box>
                            </Stack>
                        ))}
                    </Paper>

                    {/* Info Cards */}
                    {[1, 2].map((item) => (
                        <Paper key={item} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                            <Skeleton variant="text" width="60%" height={24} sx={{ mb: 2 }} />
                            <Skeleton variant="text" width="100%" height={16} sx={{ mb: 1 }} />
                            <Skeleton variant="text" width="90%" height={16} sx={{ mb: 1 }} />
                            <Skeleton variant="text" width="70%" height={16} />
                        </Paper>
                    ))}
                </Grid>
            </Grid>
        </Box>
    );
};

export default DashboardSkeleton; 